// Resolve width and height css inputs
export const resolveCSSDimensions = (
  dimension: number | string | undefined
) => {
  return typeof dimension === "number" ? `${dimension}px` : dimension || "100%";
};
